import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavbarDesktop = _resolveComponent("NavbarDesktop")
  const _component_NavbarMobile = _resolveComponent("NavbarMobile")

  return (_ctx.$responsive.desktop || !_ctx.$responsive.mobile)
    ? (_openBlock(), _createBlock(_component_NavbarDesktop, {
        key: 0,
        ref: "navbar"
      }, null, 512 /* NEED_PATCH */))
    : (_openBlock(), _createBlock(_component_NavbarMobile, {
        key: 1,
        ref: "navbar"
      }, null, 512 /* NEED_PATCH */))
}